export default "__VITE_ASSET__CySGs4TT__"